import { AnnouncementInterface } from '@careapp/angular-sdk';
import { ReducerStateFactory } from './state-factory.reducer';

import * as actions from '../actions/index';

export class AnnouncementReducer extends ReducerStateFactory<AnnouncementInterface> {
  allReducer(stateData, action) {
    switch (action.type) {
      case actions.Announcements.REQUEST_ALL:
        return { ...stateData, entities: {}, ids: [], loadingAll: true };
    }
    return super.allReducer(stateData, action);
  }
}

export const state = new AnnouncementReducer(actions.Announcements);

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
